import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'Common';

export const PartnerLogo = ({ imageSrc, logoLink, altText }) => {
  if (!imageSrc) {
    return null;
  }
  if (!logoLink) {
    return (
      <div className="partner-logo-bubble">
        <img src={imageSrc} alt={altText} className="partner-logo-bubble__image" />
      </div>
    );
  }

  return (
    <div className="partner-logo-bubble">
      <Link href={logoLink}>
        <img src={imageSrc} alt={altText} className="partner-logo-bubble__image" />
      </Link>
    </div>
  );
};

PartnerLogo.propTypes = {
  imageSrc: PropTypes.node,
  logoLink: PropTypes.string,
  altText: PropTypes.string.isRequired
};
